import { createSelector } from "reselect";
import { formatVacationRequest } from "../../components/planning/planning.utils";
export const selectPresence = state => state.presence || {};

export const selectPresenceSelectedUserVacations = createSelector([selectPresence], (presenceState = {}) => {
  const vacations =
    (presenceState.selectedUserVacations &&
      presenceState.selectedUserVacations.map(vacation => formatVacationRequest(vacation))) ||
    [];

  return vacations;
});



// WEBPACK FOOTER //
// src/redux/selectors/presenceSelector.js